import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { DateFormat } from '@shared-enums';
import { WorkingHours } from '@shared-models';
import { BikeHttpService } from '@shared-services';
import moment from 'moment';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [TranslateModule, MatButtonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent implements OnInit {
  //#region Dependencies

  private bikeHttpService = inject(BikeHttpService);
  private destroyRef = inject(DestroyRef);

  //#endregion

  //#region Properties

  workingHours = signal<WorkingHours>({} as WorkingHours);

  //#endregion

  //#region Lifecycle Hooks

  ngOnInit(): void {
    this.initWorkingHours();
  }

  //#endregion

  //#region Init

  private initWorkingHours(): void {
    this.bikeHttpService
      .getWorkingHours(
        moment(new Date()).format(DateFormat.YearMonthDay),
        moment(new Date()).format(DateFormat.YearMonthDay),
      )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(this.handleWorkingHours.bind(this));
  }

  //#endregion

  //#region Handlers

  private handleWorkingHours(workingHours: WorkingHours[]): void {
    this.workingHours.set(workingHours[0]);
  }

  //#endregion
}
